
import { eAuditState, eUpdateType, iVirtualKeyBoard } from '@/interface/virtual-keyboard';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
@Component
export default class extends Vue {
  @Prop() info!: iVirtualKeyBoard;
  @Prop() selectTypeIndex!: eUpdateType;
  @Prop() auditID!: string; //审核ID
  @Prop() isBatchAudit!: boolean; //是否批量审核
  type: number = eUpdateType.NETFRIEND;
  pendingView = eUpdateType.PENDINGREVIEW;
  pass = eAuditState.PASS;
  reject = eAuditState.REJECT;
  typeList: object[] = [
    { id: eUpdateType.OFFICIAL, name: '官方推荐' },
    { id: eUpdateType.NETFRIEND, name: '网友上传' },
    // { id: 1, name: '官方推荐' },
    // { id: 2, name: '网友上传' },
  ];
  getStateName(type: number) {
    switch (type) {
      case 0:
        return '待审核';

      case 2:
        return '审核未通过';
    }
  }
  @Emit()
  close() {}

  @Emit()
  auditVirtualKeyboard(is_approved: number) {
    this.$emit('auditVirtualKeyboard', this.info.file_id.toString(), this.type, is_approved);
  }
}
